"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = require("../tools/Widget");
var PhoneLabel = (function (_super) {
    __extends(PhoneLabel, _super);
    function PhoneLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PhoneLabel.prototype.init = function () {
        var _this = this;
        this.el.one('mouseup', function (e) { _this.handleClick(e); });
    };
    PhoneLabel.prototype.handleClick = function (event) {
        this.el.text(this.el.data('tel'));
        this.el.prop('href', 'tel: ' + this.el.data('tel'));
    };
    return PhoneLabel;
}(Widget_1.Widget));
exports.PhoneLabel = PhoneLabel;
